import React from "react";
import './Body22.css';
import {Link} from "react-router-dom"
import picture335 from './source/picture335.png'
import picture336 from './source/picture336.png'
import picture337 from './source/picture337.png'
import picture338 from './source/picture338.png'
import picture339 from './source/picture339.png'
import picture340 from './source/picture340.png'
import picture341 from './source/picture341.png'
import picture356 from './source/picture356.png'
import picture357 from './source/picture357.png'
import picture358 from './source/picture358.png'
import picture359 from './source/picture359.png'
import picture360 from './source/picture360.png'
import picture361 from './source/picture361.png'





function Body22() {

  return (
    <div className="body22">
      <div className="body22-box1">
        <div className="body22-box2">
          <div className="body22-box3">Halenkovice</div>
          <div className="body22-box5"><div className="body22-box4"></div></div>
          <div className="body22-box6">
          <img className="body22-box6-picture" src={picture336} alt="picture1"/>
          <img className="body22-box6-picture" src={picture339} alt="picture1"/>
          <img className="body22-box6-picture2" src={picture337} alt="picture1"/>
          <img className="body22-box6-picture2" src={picture338} alt="picture1"/>
          <img className="body22-box6-picture2" src={picture340} alt="picture1"/>
          <img className="body22-box6-picture2" src={picture341} alt="picture1"/>
          <img className="body22-box6-picture" src={picture335} alt="picture1"/>
          <img className="body22-box6-picture2" src={picture356} alt="picture1"/>
          <img className="body22-box6-picture2" src={picture357} alt="picture1"/>
          <img className="body22-box6-picture2" src={picture358} alt="picture1"/>
          <img className="body22-box6-picture2" src={picture359} alt="picture1"/>
          <img className="body22-box6-picture2" src={picture360} alt="picture1"/>
          <img className="body22-box6-picture" src={picture361} alt="picture1"/>
          </div>
          <div className="body22-box8"><div className="body22-box7"><Link to="/PageProjekty">Zpět</Link></div></div>
        </div> 
      </div> 
    </div>
  );
}

export default Body22;
